import { useState } from 'react'

import { useCurrentUser } from '@/features/auth/state/auth'

import RegimeTributarioSelector from '@/components/form/shared/regime-tributario-selector'
import { ProdutosSelector } from '@/components/form/shared/produtos-selector'
import { PageLayout } from '@/layouts'
import { Button } from '@/components/ui/button'
import { ROUTE_BUILDERS } from '@/config/routes'
import { TypeContrato } from '@/features/agreement/utils/enum'

function LinkPopup({ link, onClose }: { link: string; onClose: () => void }) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link)
      alert('Link copiado para a área de transferência!')
    } catch (error) {
      console.error('Erro ao copiar link:', error)
    }
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40" onClick={onClose}>
      <div
        className="bg-white p-4 rounded shadow w-96"
        onClick={e => e.stopPropagation()} // Evita fechar ao clicar dentro
      >
        <h2 className="text-xl font-bold mb-2">Link Gerado</h2>
        <p className="mb-4 break-all">{link}</p>
        <div className="flex justify-end space-x-2">
          <Button onClick={handleCopy}>Copiar</Button>
          <Button variant="secondary" onClick={onClose}>
            Fechar
          </Button>
        </div>
      </div>
    </div>
  )
}

export default function MinutaCreateRead() {
  const [linkGerado, setLinkGerado] = useState<string | null>(null)
  const [showPopup, setShowPopup] = useState(false)
  const [regimeTributario, setRegimeTributario] = useState<string | null>(null)
  const [produtosSelecionados, setProdutosSelecionados] = useState<string[]>([])
  const user = useCurrentUser()

  const contratos: TypeContrato[] = [
    TypeContrato.PRINCIPAL,
    (regimeTributario as TypeContrato) || TypeContrato.DEFAULT,
    ...(produtosSelecionados?.map(produto => produto as TypeContrato) || [TypeContrato.DEFAULT])
  ]

  const handleProdutoChange = (produto: string) => {
    setProdutosSelecionados(prev => (prev.includes(produto) ? prev.filter(p => p !== produto) : [...prev, produto]))
  }

  const handleRegimeChange = (value: string) => {
    setRegimeTributario(value)
    setProdutosSelecionados([]) // Reset products when regime changes
  }

  const handleCreateLink = async () => {
    try {
      const url = ROUTE_BUILDERS.minuteRead(user?.id_tenant!, contratos.join(','))
      const fullLink = `${window.location.hostname}${url}`
      setLinkGerado(fullLink)
      setShowPopup(true)
    } catch (error) {
      console.error('Erro ao criar/linkar Minuta:', error)
    }
  }

  return (
    <PageLayout title="Proposta de Minuta" description="Contrato prévio. Somente para leitura para o contratante">
      {/* Regime Tributário */}
      <RegimeTributarioSelector value={regimeTributario} onChange={handleRegimeChange} />

      {/* Lista de Produtos */}
      <ProdutosSelector
        regimeTributario={regimeTributario}
        selectedProducts={produtosSelecionados}
        onProductChange={handleProdutoChange}
        useIdsAsNames={true}
      />

      {/* Botão para "Criar Link Minuta" */}
      <div className="flex space-x-4 mt-4">
        <Button
          type="button"
          onClick={handleCreateLink}
          className="bg-primary hover:bg-primary-hover text-primary-foreground"
        >
          Criar Link Minuta
        </Button>
      </div>
      {showPopup && linkGerado && <LinkPopup link={linkGerado} onClose={() => setShowPopup(false)} />}
    </PageLayout>
  )
}
